<base-dialog title="Image Evidence">
   <img class="image-evidence" [src]="data" alt="Image Evidence">
</base-dialog>